// @vue/component
import BlacklistItem from './BlacklistItem';
import EmptyList from '@/components/Common/EmptyList';
import AddNewElementButton from '@/components/Common/AddNewElementButton';

export default {
  name: 'Blacklist',

  components: {
    BlacklistItem,
    EmptyList,
    AddNewElementButton,
  },

  props: {
    blacklist: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'blacklist/getList']);
    },
  },
  methods: {
    handleChangePage(page) {
      this.$store.dispatch('blacklist/changePage', page);
    },
  },
};
